import styled from 'styled-components/macro';
import { extraSmallScreens, lowHeightScreens, mediumScreens, smallScreens } from '../../common/fontElements';
import * as colors from '../../common/colorConstants';

export const BoldSpan = styled.span`
  font-size: 11px;
  font-weight: 500;
  color: #313f5a;
`;

export const Column = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 10px;
`;

export const ColumnTitle = styled.div`
  display: flex;
  font-size: 10px;
  margin-right: 50px;
`;

export const Container = styled.div`
  display: flex;
  padding: 25px 15px 25px 0px;
  justify-content: space-between;
  align-items: center;
  margin: 0px;
  border-bottom: 1px solid #d8e8ef;
  @media screen and (max-height: ${smallScreens}), screen and (max-width: ${smallScreens}) {
    padding: 15px 15px 15px 0px;
  }
`;

export const FieldTitle = styled.p`
  margin: 0px;
`;

export const HeaderRow = styled.div`
  display: flex;
  padding: 15px 40px 0px 55px;
  justify-content: space-between;
  align-items: center;
  margin: 0px;
  @media screen and (max-height: ${smallScreens}), screen and (max-width: ${smallScreens}) {
    padding: 15px 40px 8px 55px;
  }
`;

export const LastItem = styled.div`
  padding: 0px 0px 0px 20px;
  text-align: center;
  @media screen and (max-width: ${mediumScreens}) {
    font-size: 9px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 8px;
  }
`;

export const NotLastItem = styled.div`
  padding: 0px 20px;
  border-right: 1px solid #d8e8ef;
  text-align: center;
  font-size: 10px;
  @media screen and (max-width: ${mediumScreens}) {
    font-size: 9px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 8px;
  }
`;

export const RefundAmountsList = styled.ul`
  font-family: lato, sans-serif;
  font-weight: 400;
  line-height: 1.8rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  font-size: 11px;
  align-items: flex-start;
  padding-right: 10px;
  padding-left: 0;
  list-style: none;
  @media screen and (max-height: ${extraSmallScreens}), screen and (max-width: ${extraSmallScreens}) {
    font-size: 9px;
  }

  > li {
    margin-bottom: 5px;
  }
`;

export const OrderedItemsList = styled(RefundAmountsList)`
  list-style-type: disc;

  > li {
    padding-left: 5px;
    margin-bottom: 5px;
  }
`;

export const OrderField = styled.div`
  font-size: 12px;
  @media screen and (max-width: ${mediumScreens}) {
    font-size: 10px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 9px;
  }
`;

export const ResultsColumn = styled.div`
  font-family: lato, sans-serif;
  font-weight: 400;
  line-height: 1.8rem;
  width: 100%;
  display: flex;
  font-size: 11px;
  align-items: flex-start;
  padding-right: 10px;
  white-space: pre-wrap;
  word-break: break-word;
  justify-content: ${(props) => props.$justifyContent || 'initial'};
  @media screen and (max-height: ${extraSmallScreens}), screen and (max-width: ${extraSmallScreens}) {
    font-size: 9px;
  }
`;

export const ResultsColumnEllipsis = styled(ResultsColumn)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
`;

export const ResultArrayWrapper = styled(ResultsColumnEllipsis)`
  flex-direction: column;
`;

export const ResultsTextEllipsis = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline;
`;
export const ResultsTextArray = styled.div`
  margin-top: 12px;
  white-space: break-spaces;
`;

export const ResultsArrayItemsNumberBadge = styled.div`
  width: 16px;
  line-height: 16px;
  border-radius: 50%;
  text-align: center;
  background-color: ${colors.green1};
  font-size: 10px;
  color: ${colors.whiteText};
  margin: 0 6px 0 0;
  padding: 0px 11px 0px 6px;
`;

export const MoreInfoDropdownButton = styled.img`
  width: 10px;
  height: 7px;
  margin-right: 5px;
  cursor: pointer;
  position: relative;
  top: 5px;
`;

export const ResultsColumnHeader = styled.div`
  font-family: lato, sans-serif;
  font-weight: 400;
  line-height: 1.8rem;
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 9px;
  color: #7f7f7f !important;
  padding-right: 10px;
  justify-content: ${(props) => props.$justifyContent || 'initial'};
`;

export const Row = styled.div`
  display: flex;
  padding: 15px 40px 15px 55px;
  justify-content: space-between;
  align-items: flex-start;
  margin: 0px;
  border-bottom: 1px solid #d8e8ef;
  @media screen and (max-height: ${smallScreens}), screen and (max-width: ${smallScreens}) {
    padding: 10px 40px 10px 55px;
  }
`;

export const RowVertical = styled(Row)`
  flex-direction: column;
  padding: 15px 15px 15px 15px;
`;

export const ShippingAddressWrapper = styled.div`
  padding-bottom: 20px;
  border-bottom: 1px solid #d8e8ef;
`;

export const Spreadsheet = styled.div`
  margin: 20px 0px 0px;
  @media screen and (max-height: ${smallScreens}), screen and (max-width: ${smallScreens}) {
    margin: 10px 0px 0px;
  }
`;

export const TitleText = styled.p`
  font-family: Lato;
  font-size: 12px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: 0px;
  text-align: left;
  color: ${colors.black1};
  padding: 0px 25px;
  margin: 0px;
  @media screen and (max-width: ${mediumScreens}) {
    font-size: 13px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 12px;
  }
`;

export const TitleTextLight = styled(TitleText)`
  padding-left: 30px;
  font-family: 'Roboto', sans-serif;
  font-size: 10px;
  font-weight: 500;
  line-height: 18px;
  color: #6d7991;
`;

export const SubTitleText = styled(TitleText)`
  padding: 0 0 7px 30px;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  line-height: 18px;
  color: #313f5a;
`;

export const IndentedTitleText = styled(TitleText)`
  margin-left: 55px;
  padding: 0 0 10px 0;
  font-weight: 500;
  line-height: 18px;
  color: #313f5a;
`;

export const SubTitleTextLight = styled(TitleTextLight)`
  margin: 0;
  padding-left: 30px;
`;

export const TitleRow = styled.div`
  display: flex;
  padding: 10px 30px 10px 30px;
  justify-content: flex-start;
  align-items: center;
  margin: 0px;
  border-bottom: 1px solid #d8e8ef;
  @media screen and (max-height: ${smallScreens}), screen and (max-width: ${smallScreens}) {
    padding: 8px 15px 8px 30px;
  }
`;

export const UppercaseSpan = styled.span`
  text-transform: uppercase;
`;

export const MultipleLineContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
